/* Formatting. Times are shown in India time; the server speaks UTC. */

const IST = 'Asia/Kolkata';

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', { timeZone: IST, day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
}

export function dateOnly(iso: string | null | undefined): string {
  if (!iso) return '—';
  // A bare YYYY-MM-DD is a calendar date already; do not shift it through UTC.
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00+05:30`) : new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-IN', { timeZone: IST, day: 'numeric', month: 'short', year: 'numeric' });
}

/** ₹ with Indian grouping, from the server's decimal string. Display only. */
export function money(amount: string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '—';
  const n = Number(amount);
  if (!Number.isFinite(n)) return amount;
  return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** "4 min 12 s left", or "Time is up". */
export function countdown(iso: string, now: number): string {
  const ms = new Date(iso).getTime() - now;
  if (!Number.isFinite(ms)) return '—';
  if (ms <= 0) return 'Time is up';
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h} h ${m} min left`;
  if (m > 0) return `${m} min ${sec} s left`;
  return `${sec} s left`;
}

export function secondsLeft(iso: string, now: number): number {
  return Math.floor((new Date(iso).getTime() - now) / 1000);
}

/** A datetime-local input value (India time) to RFC 3339 UTC. */
export function localInputToUtc(value: string): string {
  const d = new Date(`${value}:00+05:30`);
  return d.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

/** An RFC 3339 instant as a datetime-local value in India time. */
export function utcToLocalInput(iso: string): string {
  const d = new Date(new Date(iso).getTime() + 5.5 * 3600 * 1000);
  return d.toISOString().slice(0, 16);
}

export function km(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return `${n.toFixed(1)} km`;
}
